var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-preview tc no_data font-deep-gray-xxs"},[_vm._v("\n    无数据\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }